import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useHistory, useParams } from "react-router-dom";

// SHARED
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";

//SERVICES
import { fetchTrainPlan, updateTrainPlan } from "Services/delivery.services";

//HELPERS
import { decode, toaster } from "Helpers/index";
import { isNil } from "lodash";

//SCSS
import "../parcel-tracking-view.scss";

// COMPONENTS
import ParcelTrackingEnrouteViewComponent from "Components/delivery-management/parcel-tracking-view/enroute-view-component";

import { useQuery } from "Hooks/index";

const useParcelTracking = ({ decodedTrainID, setTrainDetails, handleResetModalState }) => {
  useEffect(() => {
    fetchTrainPlanDetails();
  }, []);

  const fetchTrainPlanDetails = async () => {
    const responseData = await fetchTrainPlan(decodedTrainID);
    if (responseData && !responseData.error) {
      setTrainDetails(responseData);
    } else {
      toaster("error", "Cannot fetch train");
    }
  };

  const handleUpdateRoute = async (input) => {
    const responseData: any = await updateTrainPlan(input);

    if (!isNil(responseData) && responseData.success) {
      toaster("success", "Successfully updated train plan.");
      handleResetModalState();
      setTrainDetails(responseData.data?.trainPlan);
    } else {
      toaster("error", "Failed to update train plan. Please try again.");
    }
  };

  return {
    fetchTrainPlanDetails,
    handleUpdateRoute,
  };
};

const ParcelTrackingEnrouteViewPage = ({}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const query = useQuery();
  const { id } = useParams<{ id: string }>();
  const decodedTrainID = decode(id);
  const [trainDetails, setTrainDetails] = useState<any>({});

  const initialModal = {
    open: false,
    type: "",
    record: {},
  };

  const [callModal, setCallModal] = useState<any>(<></>);
  const [modal, setModal] = useState<any>(initialModal);

  const onBack = () => {
    const previousUrl: string | undefined = query.get("from") || undefined;
    previousUrl
      ? history.push(decodeURIComponent(previousUrl))
      : history.goBack();
  };

  const handleResetModalState = () => {
    setModal(initialModal);
  };

  const { fetchTrainPlanDetails, handleUpdateRoute } = useParcelTracking({
    decodedTrainID,
    setTrainDetails,
    handleResetModalState,
  });

  const modalPackage = {
    callModal,
    setCallModal,
    modal,
    setModal,
    handleUpdateRoute,
    handleResetModalState,
  };

  return (
    <div>
      <Helmet>
        <title>{t("title.deliveryManagement")}</title>
      </Helmet>
      <div className="pt-20 pl-20 flex-justify-space-between">
        <ModuleTitleBar
          titleText={t("title.deliveryManagement")}
          haveSubtitle
          subtitleText={t("title.enroute")}
        />
      </div>
      <ParcelTrackingEnrouteViewComponent
        info={trainDetails}
        onBack={onBack}
        modalPackage={modalPackage}
      />
    </div>
  );
};

export default ParcelTrackingEnrouteViewPage;
